import { useMemo } from 'react'

const AddObjectDropdown = ({ data }) => {
  const getIcon = (name) => {
    switch (name) {
      case 'payment':
        return 'fal fa-money-bill-1-wave'
      case 'email_message':
        return 'fal fa-at'
      case 'time_entry':
        return 'fal fa-timer'
      case 'product':
        return 'fal fa-box'
      case 'budget':
        return 'fal fa-money-check-edit'
      case 'contact':
        return 'fal fa-id-card'
      case 'product_set':
        return 'fal fa-boxes-stacked'
      default:
        return null
    }
  }

  const menuLinks = useMemo(() => {
    let links = []

    data.sidebar.add_links.map((link) => {
      if (link.visible) {
        links.push({
          codename: link.name,
          name: I18n.t(`sidebar.${link.name}`),
          url: data.sidebar[`new_account_${link.name}_path`],
          icon: getIcon(link.name)
        })
      }
    })

    return links
  }, [data])

  const getPopsize = (link) => {
    if (link?.url && (link.url.includes('/invoices') || link.url.includes('/contracts'))) {
      return 'middle'
    } else {
      return ''
    }
  }

  return (
    <ul className="dropdown-menu in-sidebar">
      {menuLinks.map((link, index) => (
        <li key={index}>
          <a
            href={link.url ? link.url : '#'}
            className={link.url ? 'ajax-popup' : 'disabled'}
            data-popsize={getPopsize(link)}
          >
            <i className={link.icon || `cico sidebar-sub-${link.codename.replace('_', '-')}`}></i>
            <div className="text">{link.name}</div>
          </a>
        </li>
      ))}
      <li className="edit-sidebar-add-links">
        <a href={data.settings_personalization_path}>{I18n.t('edit-sidebar-links')}</a>
      </li>
    </ul>
  )
}

export default AddObjectDropdown
